// todas las constantes para usuarios
export const LOADING_DASHBOARD_TEACHER = 'LOADING_DASHBOARD_TEACHER'
export const SHOW_PERFIL_USER = 'SHOW_PERFIL_USER'
